export const DASHBOARD_CANCEL = 'DASHBOARD_CANCEL';
export const LIST_BALANCE = 'LIST_BALANCE';
export const LIST_DASHBOARD = 'LIST_DASHBOARD';
